import http from '@/services/http'
import httpAuth from '@/services/httpAuth'

export function login ({ email, senha }) {
  return http.post('/auth/login', { email, senha })
}

export function refresh ({ refreshToken }) {
  return http.post('/auth/refreshToken', { refreshToken })
}

export async function confirmaSenha (dados) {
  let token = await httpAuth.post('/auth/confirma-senha', dados)
  return token
}

export function logout ({ refreshToken }) {
  return http.post('/auth/logout', { refreshToken })
}
